export default __webpack_public_path__ + "static/media/gift-yellow-small.e78583b6.svg";